import React, { Component, PropTypes } from 'react';
import Modal from 'common/components/Modal';
import cx from 'classnames';
import Datepicker from 'common/components/Datepicker';

class VacationModal extends Component {
  constructor(props) {
    super(props);

    if (props.vacation) {
      this.state = {
        ...props.vacation,
        start_hour: props.vacation.start_hour || 'AM',
        end_hour: props.vacation.end_hour || 'AM',
      };
    } else {
      this.state = { start_hour: 'AM', end_hour: 'AM' };
    }

    this.onDateChange = this.onDateChange.bind(this);
    this.onHourChange = this.onHourChange.bind(this);
    this.onCommentChange = this.onCommentChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  onDateChange = fieldName => date => {
    this.setState({
      [fieldName]: date.target.value,
    });
  };

  onHourChange = (fieldName, value) => () => {
    this.setState({
      [fieldName]: value,
    });
  };

  onCommentChange = evt => {
    this.setState({
      comment: evt.target.value,
    });
  };

  onSave = () => {
    this.props.onSaved(this.state).then(json => {
      if (json[''] && json[''][0]) {
        this.setState({ error: json[''][0] });
      }
    });
  };

  onCancel = () => {
    this.props.onClose();
  };

  render() {
    const { title } = this.props;
    const { start_date, end_date, comment, error } = this.state;

    const getHourClassname = (fieldName, value) =>
      cx('ui button', {
        active: this.state[fieldName] && this.state[fieldName] === value,
      });

    return (
      <Modal isOpened={true}>
        <div className="header">{title}</div>
        <div className="content">
          {error && <div className="ui error message">{error}</div>}
          <div className="ui grid form">
            <div className="eight wide column">
              <div className="required field">
                <label>A partir du</label>
                <Datepicker
                  identifier="start_date"
                  name="start_date"
                  value={start_date}
                  onChange={this.onDateChange('start_date')}
                />
              </div>
            </div>
            <div className="eight wide column">
              <div className="field">
                <label>&nbsp;</label>
                <div className="ui buttons separated">
                  <div
                    className={getHourClassname('start_hour', 'AM')}
                    onClick={this.onHourChange('start_hour', 'AM')}
                  >
                    Matin
                  </div>
                  <div
                    className={getHourClassname('start_hour', 'PM')}
                    onClick={this.onHourChange('start_hour', 'PM')}
                  >
                    Après-midi
                  </div>
                </div>
              </div>
            </div>
            <div className="eight wide column">
              <div className="required field">
                <label>Retour prévu le</label>
                <Datepicker
                  identifier="end_date"
                  name="end_date"
                  value={end_date}
                  onChange={this.onDateChange('end_date')}
                />
              </div>
            </div>
            <div className="eight wide column">
              <div className="field">
                <label>&nbsp;</label>
                <div className="ui buttons separated">
                  <div
                    className={getHourClassname('end_hour', 'AM')}
                    onClick={this.onHourChange('end_hour', 'AM')}
                  >
                    Matin
                  </div>
                  <div
                    className={getHourClassname('end_hour', 'PM')}
                    onClick={this.onHourChange('end_hour', 'PM')}
                  >
                    Après-midi
                  </div>
                </div>
              </div>
            </div>
            <div className="sixteen wide column">
              <div className="field">
                <label>Commentaire</label>
                <input
                  type="text"
                  defaultValue={comment}
                  onChange={this.onCommentChange}
                  name="comment"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="actions">
          <button className="ui button" onClick={this.onCancel}>
            Annuler
          </button>
          <button
            className="ui primary labeled icon button"
            onClick={this.onSave}
          >
            <i className="icon save" />
            Enregistrer
          </button>
        </div>
      </Modal>
    );
  }
}

VacationModal.propTypes = {
  title: PropTypes.string,
  vacation: PropTypes.object,
  onSaved: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  error: PropTypes.string,
};

export default VacationModal;



// WEBPACK FOOTER //
// ./src/modules/saas/users/vacation/VacationModal.js